import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Job } from '../../../vas/business-objects/job/job.model';
import { VasAppFacade } from '../../../vas/services/vas-app-facade.service';
import { SearchAsYouTypeDataProviderService } from '../search-as-you-type/search-as-you-type-data-provider.service';
import { SearchResultModel } from '../search-as-you-type/search-result.model';

@Injectable()
export class JobPickerControlDataProviderService extends SearchAsYouTypeDataProviderService {

    static id = 'JobPicker';

    constructor(protected appFacade: VasAppFacade) {
        super();
    }

    getIdentifier(): string {
        return JobPickerControlDataProviderService.id;
    }

    getResults(searchValue: string): Observable<Array<SearchResultModel>> {
        return this.appFacade.objects.job.store.getBy(job => (searchValue && job.reference.toLocaleLowerCase().indexOf(searchValue.toLocaleLowerCase()) !== -1) || !searchValue)
            .map(jobs => jobs.sort((a, b) => a.reference.localeCompare(b.reference)))
            .map(jobs => jobs.map(job => this.toResult(job)));
    }

    getResult(id: string): Observable<SearchResultModel> {
        return this.appFacade.objects.job.store.get(id)
            .map(job => this.toResult(job));
    }

    toResult(job: Job): SearchResultModel {
        return {
            id: job.id,
            text: job.reference,
            value: job.id
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/atoms/job-picker/job-picker-control-data-provider.service.ts